import { useState } from "react";

// Component Imports
import { AutocompleteInput } from "@/components/Inputs";
import {
  Button,
  Dialog,
  DialogActions,
  DialogContent,
  DialogContentText,
  DialogTitle,
} from "@mui/material";

// Type Imports
import { ISelectOption } from "@pulse-ui/types/components/DropdownInput";
import { IVenueApiKey } from "@pulse-ui/codegen/generated_ts/authn";

interface IProps {
  open: boolean;
  accounts: IVenueApiKey[];
  portfolioSelectOptions: ISelectOption[];
  handleOpen: () => void;
  handleStartDefaultConfig: (selected_account: ISelectOption) => void;
}

const entity_type_options: ISelectOption[] = [
  { label: "Account", value: "account" },
  { label: "Portfolio", value: "portfolio" },
];
const ACCOUNT = "account";

const DefaultConfigModal = ({
  open,
  accounts,
  portfolioSelectOptions,
  handleOpen,
  handleStartDefaultConfig,
}: IProps) => {
  const [selectedEntityType, setSelectedEntityType] = useState<ISelectOption>(
    entity_type_options[0]
  );

  const [selectedEntity, setSelectedEntity] = useState<ISelectOption>({
    label: accounts[0]?.key_id || "",
    value: accounts[0]?.key_id || "",
  });

  const accountSelectOptions: ISelectOption[] = accounts.map((account) => ({
    label: account.key_id || "",
    value: account.account_id || "",
  }));

  const handleEntityTypeChange = (
    _: React.SyntheticEvent,
    newValue: ISelectOption | null
  ) => {
    if (newValue) {
      if (newValue.value === ACCOUNT) {
        setSelectedEntity({
          label: accounts[0]?.key_id || "",
          value: accounts[0]?.account_id || "",
        });
      } else {
        setSelectedEntity({
          label: portfolioSelectOptions[0]?.label || "",
          value: portfolioSelectOptions[0]?.value || "",
        });
      }

      setSelectedEntityType(newValue);
    }
  };

  const handleEntitySelectionChange = (
    _: React.SyntheticEvent,
    newValue: ISelectOption | null
  ) => {
    if (newValue) {
      setSelectedEntity(newValue);
    }
  };

  return (
    <div>
      <Dialog
        open={open}
        onClose={handleOpen}
        aria-labelledby="alert-dialog-title"
        aria-describedby="alert-dialog-description"
      >
        <DialogTitle
          id="alert-dialog-title"
          sx={{
            fontFamily: "Lato, sans-serif",
            backgroundColor: "#0c1835",
            color: "#ebe93e",
          }}
        >
          Default Configuration
        </DialogTitle>
        <DialogContent sx={{ backgroundColor: "#e8eaef" }}>
          <DialogContentText
            id="alert-dialog-description"
            sx={{
              fontFamily: "Lato, sans-serif",
              margin: "0.75rem 0",
              color: "#091229",
            }}
          >
            Please select an entity type followed by an account or portfolio
            below to assign the default alerts configuration.
          </DialogContentText>

          <AutocompleteInput
            value={{
              label:
                selectedEntityType?.label ||
                entity_type_options[0]?.label ||
                "",
              value:
                selectedEntityType?.value ||
                entity_type_options[0]?.value ||
                "",
            }}
            inputLabel=""
            onChange={handleEntityTypeChange}
            disabled={entity_type_options.length < 1}
            options={entity_type_options}
          />

          <AutocompleteInput
            value={{
              label: selectedEntity?.label || "",
              value: selectedEntity?.value || "",
            }}
            inputLabel=""
            onChange={handleEntitySelectionChange}
            disabled={accounts.length < 1}
            options={
              selectedEntityType.value === ACCOUNT
                ? accountSelectOptions
                : portfolioSelectOptions
            }
          />
        </DialogContent>
        <DialogActions sx={{ backgroundColor: "#e8eaef" }}>
          <Button
            sx={{
              color: "#fe3c46",
              fontWeight: "bold",
              fontFamily: "Lato, sans-serif",
            }}
            onClick={handleOpen}
          >
            Cancel
          </Button>
          <Button
            sx={{
              color: "#253c63",
              fontWeight: "bold",
              fontFamily: "Lato, sans-serif",
            }}
            onClick={() => {
              if (
                selectedEntity &&
                selectedEntity?.value &&
                selectedEntity?.value.length > 0
              ) {
                handleStartDefaultConfig(selectedEntity);
                handleOpen();
              }
            }}
          >
            Submit
          </Button>
        </DialogActions>
      </Dialog>
    </div>
  );
};

export default DefaultConfigModal;
